import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Background from "../../../assets/images/search-icon.png";

const SearchBar = ({
  list = [],
  filterData,
  encoded = false,
  placeholder = "Search Patient By Name...",
  style,
}) => {
  const [searchVal, setSearchVal] = useState("");
  const applyFilter = (resetPage = false) => {
    const trimmed = (searchVal ?? "").trim().toLowerCase();
    const data = list?.filter((data) =>
      data?.subject?.display?.toLowerCase()?.includes(trimmed)
    );
    filterData(data, resetPage);
  };
  useEffect(() => {
    applyFilter(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list]);
  useEffect(() => {
    applyFilter(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchVal]);
  return (
    <div style={style}>
      <Form className="search-wrap" style={{ width: "100%", maxWidth: "100%" }}>
        <Form.Control
          type="search"
          placeholder={placeholder}
          className="me-2"
          aria-label="Search"
          style={{
            width: "100%",
            boxSizing: "border-box",
            backgroundImage: searchVal ? "none" : `url(${Background})`,
          }}
          value={searchVal}
          onChange={(e) => setSearchVal(e.target.value.toLowerCase())}
        />
      </Form>
    </div>
  );
};

export default SearchBar;
